// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type EditorLatexIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from editor-latex.svg
 */
export default function EditorLatexIcon(props: EditorLatexIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="EditorLatexIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M13.392 16q.237 0 .423-.108.185-.109.185-.248v-1.778q0-.149-.185-.252a.85.85 0 0 0-.423-.104H6.85q-.207 0-.267-.083-.06-.082 0-.152l5.533-5.101q.238-.21.193-.378a.75.75 0 0 0-.193-.325L6.88 2.707q-.06-.07-.007-.143.05-.075.289-.074h6.17a.8.8 0 0 0 .416-.108q.178-.109.178-.248V.356q0-.139-.178-.248A.8.8 0 0 0 13.333 0H2.904q-.238 0-.423.108-.185.109-.185.248v1.943q0 .192.11.326l.171.204 5.31 4.815q.06.07.075.178a.22.22 0 0 1-.074.195l-5.622 5.154a8 8 0 0 0-.163.2.5.5 0 0 0-.104.33v1.943q0 .139.185.248a.8.8 0 0 0 .423.108z"
        />
      </g>
    </svg>
  );
}
